import { TFunction } from 'i18next';

import { TipsStatus } from '../shared/types';

const statusMapper = (t: TFunction, status: TipsStatus): string => {
  switch (status) {
    case TipsStatus.verified:
    case TipsStatus.approved:
    case TipsStatus.questionable:
    case TipsStatus.doubted:
    case TipsStatus.deleted: {
      return t(`tips-status-${status}`);
    }
    default: {
      return t('tips-status-default');
    }
  }
};

export default { statusMapper };
